import { createSlice } from "@reduxjs/toolkit";

export const posSettingSlice = createSlice({
  name: "posSettingSlice",
  initialState: {
    apiResList: undefined,
    apiTimeReportList: undefined
  },
  reducers: {
    get_pos_settings_api_res_list: (state, action) => {
      state.apiResList = action.payload.posSettingsResData;
    },
    get_pos_time_report: (state, action) => {
        state.apiTimeReportList = action.payload.posTimeReportResData;
    },
  },
});


export const { 
    get_pos_settings_api_res_list,
     get_pos_time_report
} = posSettingSlice.actions;

export default posSettingSlice.reducer;